import React, { useEffect, useState } from 'react';
import { Checkbox } from "react-inputs-validation";
import { Alert, Col, Row } from 'reactstrap';
import "../../styles/estilos.css";
import { urlObtenerOpciones } from '../../constants/urls';

const SiNoSimple = ({
  id,
  value,
  valueSelect,
  placeholder,
  onChange,
  mensajeError,
  isSearchable,
  peticiones,
  valorPadre,
  esDependiente,
  codPadre,
  validate,
  hasError,
  validationCallback,
  values,
  setLoading,
  isMulti,
  valorDependiente,
  required,
  esBloqueante,
  errorBloqueante,
  disabled
}) => {

  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (values) {
      setOptions(values);
    }
  }, [values]);

  useEffect(() => {
    if (peticiones) {
      obtenerOpciones();
    }
  }, [esDependiente && valorPadre]);

    const obtenerOpciones = async () => {
  
  
  
      setLoading(true)
  
      let url = `${urlObtenerOpciones}${peticiones.url}`;
      let body = peticiones.metodo == 'POST' ? JSON.stringify(peticiones.body) : null
  
  
      if (esDependiente) {
        if (peticiones.metodo == 'POST') {
          body = body.replace("$" + codPadre, valorPadre)
        }
  
        if (peticiones.metodo == 'GET') {
          url = url.replace("$" + codPadre, valorPadre.value)
        }
  
  
  
  
  
      }
  
  
      try {
        const response = await fetch(url, { method: peticiones.metodo, body: body })
        const json = await response.json()
        if (json) {
  
  
  
          let aux = []
          const atributo = peticiones.atributo;
  
          // Dividir la cadena de atributo en partes usando el punto como separador
          const partes = atributo.split(".");
  
          // Inicializar una variable temporal para mantener el objeto JSON actual
          let objetoActual = json;
  
          // Iterar sobre las partes para acceder al valor anidado en el objeto JSON
          for (const parte of partes) {
            objetoActual = objetoActual[parte];
  
            // Verificar si el objeto actual es indefinido o nulo
            if (objetoActual === undefined || objetoActual === null) {
              break;
            }
          }
  
          // opciones contendrá el valor final obtenido del objeto JSON
          let opciones = objetoActual;
          //let opciones = json[peticiones.atributo]
  
          opciones.forEach(p => {
            aux.push({ ...p, value: p[peticiones.value], label: p[peticiones.label] });
          });
          setOptions(aux)
  
        }
      } catch (error) {
      }
  
      setLoading(false)
    }
  return (
    <div title={"select"}>
      <Row>
        <Col md={2} sm={6} xs={6}>
          <Checkbox
            id={`preguntaSI`}
            name={`preguntaSI`}
            checked={value === 'SI'}
            onChange={() => {
              onChange('SI');
              validationCallback(true);
            }}
            labelHtml={
              <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                SI
              </div>
            }
            validationOption={{
              name: 'preguntaSI',
              check: true,
            }}
          />
        </Col>
        <Col md={2} sm={6} xs={6}>
          <Checkbox
            id={`preguntaNO`}
            name={`preguntaNO`}
            checked={value === 'NO'}
            onChange={() => {
              onChange('NO');
              validationCallback(false);
            }}
            labelHtml={
              <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight: "bold" }}>
                NO
              </div>
            }
            validationOption={{
              name: 'preguntaNO',
              check: true,
            }}
          />
        </Col>
      </Row>

      {!value && (
        <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">
          {mensajeError}
        </div>
      )}
    </div>
  );
};

export default SiNoSimple;
